import React from 'react';
import { useWealthSavingsHeroContent } from '../../../../hooks/useWealthSavingsHeroContent';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useWealthSavingsHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, backgroundImage } = content;

  return (
    <section className="wealth-hero">
      <img
        className="wealth-hero__bg"
        src={backgroundImage}
        alt=""
        aria-hidden="true"
      />
      <div className="wealth-hero__overlay" />

      <div className="wealth-hero__inner">
        <div className="wealth-hero__content">
          {eyebrow ? <p className="wealth-hero__eyebrow">{eyebrow}</p> : null}
          <h1 className="wealth-hero__title">{title}</h1>
          {text ? <p className="wealth-hero__text">{text}</p> : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
